import React from 'react';
import Card from 'components/card/Card';
import { OrganizationListItem } from 'types/Organization';
import { NIcon } from '@innersource-nn/novoui-react';

const OrganizationCard = ({
    label,
    description,
    created,
    updated,
    organizationUri,
    owner,
    SamlGroupName,
    stats,
    tags,
}: OrganizationListItem) => {
    const bodyContent = [
        {
            icon: (
                <NIcon iconName="person" size={24} className="fill-true-blue" />
            ),
            title: 'Org. Admin',
            info: SamlGroupName,
        },
        {
            icon: (
                <NIcon iconName="cloud" size={24} className="fill-true-blue" />
            ),
            title: 'Environments',
            info: stats.environments,
        },
    ];
    const body = bodyContent.map((item, index) => {
        return (
            <div
                className="flex items-center gap-16 text-sm"
                key={`body-info-${index}`}
            >
                {item.icon}
                <div>
                    <p className="text-true-blue">{item.title}</p>
                    <p className="text-faded-blue-600 ">{item.info}</p>
                </div>
            </div>
        );
    });
    return (
        <Card
            label={label}
            uri={`/organization/${organizationUri}/`}
            type="organization"
            subheader={owner}
            body={body}
            description={description}
            updated={updated || created}
            tags={tags}
        />
    );
};

export default OrganizationCard;
